import { LANGUAGES_MAPPER } from '@shared/configs/constants';
import { LANGUAGES_SUPPORTED } from '@shared/types/enums';
import { Locale } from 'date-fns';

export const getLocaleDateFns = (locale: string): Locale => {
    switch (locale) {
        case LANGUAGES_SUPPORTED.Japanese:
            return LANGUAGES_MAPPER.japanese.dateFns;

        default:
            return LANGUAGES_MAPPER.english.dateFns;
    }
};
